// extracted by mini-css-extract-plugin
export default {"title":"zCwErUerlmDZ8dNak6P8","submitButton":"ZpC4sbUXjG23N4ZUNOM9"};